/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getKnownFollowers.defs.js'
export * as $defs from './getKnownFollowers.defs.js'
